/**
 * External Dependencies
 */
import 'jquery';
import debounce from 'lodash.debounce';
import Swiper, { Navigation, Pagination } from 'swiper';
import AOS from 'aos';
import GLightbox from 'glightbox';

$(document).on('ready', () => {
  /**
   * Viewport units
   */

  var setViewportUnits = function () {
    document.documentElement.style.setProperty(
      '--vh',
      window.innerHeight / 100 + 'px'
    );
    document.documentElement.style.setProperty(
      '--vw',
      document.documentElement.clientWidth / 100 + 'px'
    );
  };

  document.addEventListener('load', setViewportUnits());

  window.addEventListener('resize', debounce(setViewportUnits, 100));

  /**
   * Accordion (vedere aedi)
   */
  $(document).on('click', '[accordion]', function () {
    var i = $(this).attr('accordion');
    if ($(this).hasClass('active-button')) {
      $(this)
        .parents('.accordions-container')
        .find('[accordion]')
        .removeClass('active-button');
      $(this)
        .parents('.accordions-container')
        .find('[accordion-index]')
        .removeClass('max-h-full')
        .addClass('max-h-0');
    } else {
      $(this)
        .parents('.accordions-container')
        .find('[accordion="' + i + '"]')
        .addClass('active-button');
      $(this)
        .parents('.accordions-container')
        .find('[accordion]')
        .not('[accordion="' + i + '"]')
        .removeClass('active-button');
      $(this)
        .parents('.accordions-container')
        .find('[accordion-index="' + i + '"]')
        .removeClass('max-h-0')
        .addClass('max-h-full');
      $(this)
        .parents('.accordions-container')
        .find('[accordion-index]')
        .not('[accordion-index="' + i + '"]')
        .removeClass('max-h-full')
        .addClass('max-h-0');
    }
  });

  /**
   * Animate on scroll
   */

  function AOSInit() {
    AOS.init({
      once: true,
      initClassName: 'js-aos-init',
      animatedClassName: 'js-aos-animate',
    });
  }
  AOSInit();

  /*
   ** Scroll to target
   */

  $('[data-scroll-target]').on('click', function (e) {
    e.preventDefault();
    window.scrollTo({
      top: $($(this).attr('data-scroll-target')).offset().top,
      behavior: 'smooth',
    });
  });

  /**
   * Sitebar compressed
   */

  const topbar = document.querySelector('.siteBar');

  if (topbar) {
    const observerElNode = document.createElement('div');

    observerElNode.classList.add('js-observer-el');

    topbar.parentNode.insertBefore(observerElNode, topbar);

    const observerEl = document.querySelector('.js-observer-el');

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.intersectionRatio < 1) {
              topbar.classList.add('siteBar--compressed');
            } else {
              topbar.classList.remove('siteBar--compressed');
            }
          } else {
            topbar.classList.add('siteBar--compressed');
          }
        });
      },
      {
        threshold: [0, 1],
      }
    );

    observer.observe(observerEl);
  }

  /*
   ** Menu toggle
   */

  const menuToggle = document.getElementById('menuToggle');

  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      e.stopPropagation();

      var self = menuToggle,
        ariaExpanded = self.getAttribute('aria-expanded');

      if (ariaExpanded == 'true') {
        self.setAttribute('aria-expanded', 'false');
      } else if (ariaExpanded == 'false') {
        self.setAttribute('aria-expanded', 'true');
      }

      document.body.classList.toggle('has-menu-open');
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        document.body.classList.contains('has-menu-open')
      ) {
        document.body.classList.remove('has-menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('#menu') || event.target.closest('#menuToggle'))
        return;

      document.body.classList.remove('has-menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    });
  }

  /*
   ** Prevent default on same-page site nav links
   */

  document.querySelectorAll('.siteNav__link[href="#"]').forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      el.blur();
    });
  });

  /*
   ** Nav items with children
   */

  const navItemsWithChildrenLv1 = document.querySelectorAll(
    '.siteNav__items > .siteNav__item--hasChildren'
  );

  function toggleSubMenuOnSmallScreens(event) {
    const target = event.target;
    const parent = target.closest('.siteNav__item--hasChildren');
    const subMenu = parent.querySelector('.siteNav__subItems');
    if (window.matchMedia('(max-width: 1023.98px)').matches) {
      event.preventDefault();

      if (subMenu) {
        parent.classList.toggle('siteNav__item--hasChildren--open');
        subMenu.classList.toggle('siteNav__subItems--open');
      }
    }
  }

  navItemsWithChildrenLv1.forEach((el) => {
    el.classList.add('siteNav__item--hasChildren_lv1');

    const link = el.querySelector('.siteNav__link');

    link.addEventListener('click', function (event) {
      toggleSubMenuOnSmallScreens(event);
    });
  });

  /**
   * Modals
   */

  /* eslint-disable */

  const closeBtnText =
    document.documentElement.lang === 'it-IT' ? 'Chiudi' : 'Close';
  const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
     <div class="gloader visible"></div>
     <div class="goverlay"></div>
     <div class="gcontainer">
     <div id="glightbox-slider" class="gslider"></div>
       <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
       <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
       <button class="gclose btn btn--fill u-bgColor-primary" tabindex="2" aria-label="Close">
         <span class="btn__icon">
           <div class="icn">
             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M4.30769 8L0 12.3077L3.69231 16L8 11.6923L12.3077 16L16 12.3077L11.6923 8L16 3.69231L12.3077 0L8 4.30769L3.69231 5.86876e-07L0 3.69231L4.30769 8Z" fill="black"/>
             </svg>
           </div>
         </span>
         <span class="btn__text">${closeBtnText}</span>
       </button>
     </div>
   </div>`;

  const glbDefaultOptions = {
    skin: 'custom',
    lightboxHTML: customLightboxHTML,
    openEffect: 'fade',
    closeEffect: 'fade',
    slideEffect: 'fade',
  };

  const glbInlineOptions = {
    selector: '.glightbox-inline',
    width: '100%',
    height: 'auto',
  };

  const lightbox = GLightbox(glbDefaultOptions);

  var lightboxInline = GLightbox({ ...glbDefaultOptions, ...glbInlineOptions });

  window.closeModal = () => {
    lightboxInline.close();
  };

  /**
   * Gallery
   */

  /* eslint-disable */
  Swiper.use([Navigation, Pagination]);

  document.querySelectorAll('.logoSlider').forEach((el) => {
    const slider = new Swiper(el.querySelector('.swiper-container'), {
      init: false,
      loop: true,
      speed: 500,
      centeredSlides: true,
      slidesPerView: 3,
      loopAdditionalSlides: 8,
      slideToClickedSlide: true,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 5,
        },
        1280: {
          slidesPerView: 6,
        },
        1440: {
          slidesPerView: 7,
        },
        1920: {
          slidesPerView: 8,
        },
        2560: {
          slidesPerView: 9,
        },
      },
    });
    slider.init();
    slider.snapGrid = [...slider.slidesGrid];
  });
  /* eslint-enable */

  /*
   ** Flex Gap
   */

  function checkFlexGap() {
    // create flex container with row-gap set
    var flex = document.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';

    // create two, elements inside it
    flex.appendChild(document.createElement('div'));
    flex.appendChild(document.createElement('div'));

    // append to the DOM (needed to obtain scrollHeight)
    document.body.appendChild(flex);
    var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
    //flex.parentNode.removeChild(flex);

    return isSupported;
  }

  if (checkFlexGap()) {
    document.documentElement.classList.add('has-flexbox-gap');
  } else {
    document.documentElement.classList.add('has-no-flexbox-gap');
  }

  /**
   * Animate counter value
   */

  function easing(x) {
    return x < 0.5
      ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2
      : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
  }

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = easing(
        Math.min((timestamp - startTimestamp) / duration, 1)
      );
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const animatedCounters = document.querySelectorAll('.js-animate-value');

  if (animatedCounters) {
    animatedCounters.forEach((el) => {
      var value = parseInt(el.textContent);

      animateValue(el, 0, value, 2000);
    });
  }
  
  /*
   ** Details
   */
  
   const details = document.querySelectorAll('details.collapsable');

   details.forEach(el => {
     const parent = el.closest('.collapsable-parent');

     if (parent) {
       var siblings = parent.querySelectorAll('details.collapsable');
     }
     
     el.addEventListener('toggle', function() {
       if (this.open) {
         this.setAttribute('tabindex', '-1');
         this.querySelector('summary').setAttribute('tabindex', '-1');
         document.activeElement.blur();
 
         if (siblings) {
          siblings.forEach(d => {
            if (d != this && d.open) {
              d.open = false;
              d.removeAttribute('tabindex');
              d.querySelector('summary').removeAttribute('tabindex');
            }
          });
          }
       }
     })
   }); 
});
